import { Component, OnInit } from "@angular/core";
import { KpiService } from "../kpi/kpi.service";

@Component({
  selector: "app-usage",
  templateUrl: "./usage.component.html",
  styleUrls: ["./usage.component.scss"],
})
export class UsageComponent implements OnInit {
  constructor(private kpiService: KpiService) {}

  districtAndSchoolsUsage;
  userLogins;
  keyword;
  userLoginsDef = `Tallies show total number of Mosaic views per month for all users,
  including Schoolzilla administrators and users who have never logged in to a Schoolzilla
  app such as Mosaic or Data Wall. Ever Logged In and Last Logged In indicate if and when
  the user has logged in to any Schoolzilla app, whereas the tallies show only Mosaic views.`;
  schoolUsageDef = `Average Monthly Usage: The percent of users who logged into Mosaic 
  at least once during the month, out of all invited users. Invited users are school leaders 
  or teachers with at least one historical login to any Schoolzilla application. Rates are 
  based on totals for a specific month, and are not cumulative. All totals exclude Schoolzilla 
  administrators. School leaders who have access to multiple schools are excluded from individual 
  school calculations; their usage is reflected in the "Central Office" row.`;
  role: string;

  ngOnInit() {
    // Clear error messages
    this.kpiService.errorMessage = null;

    this.kpiService.getUserInfo().subscribe(
      (data) => {
        this.role = data.role;
        this.kpiService.title = data.customer_name;
      },
      (error) => {
        console.error(error);
      }
    );

    this.kpiService.getDistrictAndSchoolsUsageData().subscribe(
      (data) => {
        this.districtAndSchoolsUsage = data;
        if (
          this.districtAndSchoolsUsage &&
          this.districtAndSchoolsUsage["district"]
        ) {
          this.districtAndSchoolsUsage[
            "district"
          ].definition = `Average Monthly Usage: The 
          percent of users who logged into Mosaic at least once during the month, out of all 
          invited users. Invited users are school leaders or teachers with at least one historical 
          login to any Schoolzilla application. Rates are based on totals for a specific month, 
          and are not cumulative. Excludes Schoolzilla administrators.`;
        }
      },
      (error) => {
        console.log(error);
      }
    );

    this.kpiService.getUserLoginData().subscribe(
      (data) => {
        this.userLogins = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
